import { Navigate } from "@/lib/router-compat";
import { useStaffIndustryView } from "@/hooks/useStaffIndustryView";
import type { ReactNode } from "react";

export const INDUSTRY_BUILDER_ROUTE: Record<string, string> = {
  security: "/builder", cleaning: "/cleaning-builder", "commercial-cleaning": "/cleaning-builder",
  "private-investigation": "/pi-builder", "event-staffing": "/event-builder",
  "construction-services": "/construction-builder", landscaping: "/landscaping-builder",
  "pest-control": "/pest-control-builder", "home-services": "/home-services-builder", "power-washing": "/power-washing-builder",
};

export const IndustryBuilderGuard = ({ industry, children }: { industry: string; children: ReactNode }) => {
  const { effectiveIndustry, isStaffOrAdmin } = useStaffIndustryView();
  if (isStaffOrAdmin) return <>{children}</>;
  const userIndustry = effectiveIndustry === "commercial-cleaning" ? "cleaning" : effectiveIndustry;
  const targetIndustry = industry === "commercial-cleaning" ? "cleaning" : industry;
  if (userIndustry !== targetIndustry) return <Navigate to={INDUSTRY_BUILDER_ROUTE[userIndustry] || "/builder"} replace />;
  return <>{children}</>;
};